import setOriginInterceptor from "@/authentication/native/setOriginInterceptor"
import { useQuery } from "@tanstack/vue-query"
import axios from "axios"

export interface BannerContent {
  title: string
  message: string
  pages: string[]
}

export interface EdgeConfig {
  isMaintenancePageEnabled: boolean
  isMaintenanceBannerEnabled: boolean
  maintenanceBannerContent: BannerContent | null
}

const AXIOS_INSTANCE = axios.create()
AXIOS_INSTANCE.interceptors.request.use(setOriginInterceptor)

async function fetchEdgeConfig() {
  const baseUrl = import.meta.env.VITE_PUBLIC_WEBSITE_URL
  const { data } = await AXIOS_INSTANCE.post<EdgeConfig>(
    `${baseUrl}/myaccount/api/edge-config`,
  )
  return data
}

export const useGetEdgeConfig = (enabled?: boolean) =>
  useQuery({
    queryKey: ["maintenance"],
    queryFn: fetchEdgeConfig,
    staleTime: Infinity,
    retry: false,
    enabled,
  })
